import { createAction, createReducer } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  cnpj: null,
  createdAt: '',
  id: null,
  idLegado: 0,
  nivel: null,
  companyName: '',
  status: null,
  updatedAt: '',
};

export const getPartnerProfileAction = createAction<any>(
  '@productsPage/GET_PARTNER_PROFILE_ACTION'
);

const partnerDataReducer = createReducer(INITIAL_STATE, {
  [getPartnerProfileAction.type]: (state, action) => ({
    ...state,
    cnpj: action.payload.cnpj,
    createdAt: action.payload.created_at,
    id: action.payload.id,
    idLegado: action.payload.id_legado,
    nivel: action.payload.nivel,
    companyName: action.payload.razao_social,
    status: action.payload.status,
    updatedAt: action.payload.updated_at,
  }),
});

export default partnerDataReducer;
